<app-header></app-header>

<!-- (headerInitCompleteEvent)="onHeaderInitGenerated($event)" -->
<ion-content scrollbar>
  <app-space-edit
    [spaceType]="spaceType"
  ></app-space-edit>
</ion-content>
